
export class PdaPartyAccordionType {
    accordionLabel: string;
    filterName: string;
    type: string;
}

export const pdaPartyAccordionTypesDefault: PdaPartyAccordionType[] =
    [
        {
            accordionLabel: "Attori",
            filterName: "ATTORE",
            type: "controparte"
        },
        {
            accordionLabel: "Convenuti",
            filterName: "CONVENUTO",
            type: "controparte"
        },
        {
            accordionLabel: "Intervenuti",
            filterName: "INTERVENUTO",
            type: "altraparte"
        },
        {
            accordionLabel: "Chiamati in causa",
            filterName: "CHIAMATO_IN_CAUSA",
            type: "altraparte"
        }
    ];

export const pdaPartyAccordionTypesSiecic: PdaPartyAccordionType[] =
    [
        {
            accordionLabel: "Creditori",
            filterName: "CREDITORE",
            type: "controparte"
        },
        {
            accordionLabel: "Debitori",
            filterName: "DEBITORE",
            type: "controparte"
        },
        {
            accordionLabel: "Esecutato",
            filterName: "ESECUTATO",
            type: "controparte"
        },
        {
            accordionLabel: "Esecutante",
            filterName: "ESECUTANTE",
            type: "controparte"
        },
        {
            accordionLabel: "Custode",
            filterName: "CUSTODE",
            type: "controparte"
        }
    ];

export const pdaPartyAccordionTypesCass: PdaPartyAccordionType[] =
    [
        {
            accordionLabel: "Soggetti",
            filterName: "SOGGETTI",
            type: "controparte"
        }
    ]